import { render, staticRenderFns } from "./PartnerSettingsPage.vue?vue&type=template&id=02d90d17"
import script from "./PartnerSettingsPage.vue?vue&type=script&lang=ts"
export * from "./PartnerSettingsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports